module.exports = __webpack_public_path__ + "img/hd.e088e272.jpg";